import React from 'react';

const FailedReportView = () => {

    return (
        <div className="FailedReportView">
            <div className="modal fade" id="FailedReportModal" tabIndex="-1" role="dialog" aria-labelledby="SharedOrgEmail" aria-hidden="false">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="modal-title " id="myModalLabel">Troubleshooting</div>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="false">&times;</span></button>
                        </div>
                        <div className="modal-body">
                            <div className="modal-content-body">The list below indicates possible reasons why it failed.</div>
                            <table className="custom-ag-theme spacer-margin8">
                                <thead>
                                    <tr>
                                        <th>Row</th>
                                        <th>Source</th>
                                        <th>Reason</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>2</td>
                                        <td >SampleSourceData</td>
                                        <td>FileHelpers.FileHelpersException: The delimiter ',' can't be found after the field 'IDType3' at line 2 (the record has less fields, the delimiter is wrong or the next field must be marked as optional).
                                            at FileHelpers.DelimitedField.BasicExtractString(LineInfo line)
                                            at FileHelpers.DelimitedField.ExtractFieldString(LineInfo line)
                                            at FileHelpers.FieldBase.ExtractValue(LineInfo line)
                                            at FileHelpers.RecordInfo.StringToRecord(LineInfo line)
                                            at FileHelpers.FileHelperEngine.ReadStream(TextReader reader, Int32 maxRecords, DataTable dt) </td>

                                    </tr>
                                    <tr >
                                        <td >3</td>
                                        <td >SampleSourceData</td>
                                        <td >FileHelpers.FileHelpersException: The delimiter ',' can't be found after the field 'IDType3' at line 3 (the record has less fields, the delimiter is wrong or the next field must be marked as optional).
                                            at FileHelpers.DelimitedField.BasicExtractString(LineInfo line)
                                            at FileHelpers.DelimitedField.ExtractFieldString(LineInfo line)
                                            at FileHelpers.FieldBase.ExtractValue(LineInfo line)
                                            at FileHelpers.RecordInfo.StringToRecord(LineInfo line)
                                            at FileHelpers.FileHelperEngine.ReadStream(TextReader reader, Int32 maxRecords, DataTable dt) </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-outline-secondary" data-dismiss="modal">Close</button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

FailedReportView.propTypes = {};

FailedReportView.defaultProps = {};

export default FailedReportView;
